<template>
  <form
    class="row header-toolbar"
    @submit.prevent="searchClicked()">
    <v-col cols="3">
      <v-select
        v-model="filterFactory"
        :items="selectOptions.factories"
        :menu-props="{ offsetY: true }"
        label="Factory"
        item-text="name"
        item-value="id"
        outlined
        hide-details
        dense />
    </v-col>
    <v-col cols="3">
      <v-select
        v-model="filterDesigner"
        :items="selectOptions.designers"
        :menu-props="{ offsetY: true }"
        label="Designer"
        item-text="name"
        item-value="id"
        outlined
        hide-details
        dense />
    </v-col>
    <v-col cols="3">
      <v-select
        v-model="filterMerchandiser"
        :items="selectOptions.merchandisers"
        :menu-props="{ offsetY: true }"
        label="Merchandiser"
        item-text="name"
        item-value="id"
        outlined
        hide-details
        dense />
    </v-col>
    <v-col cols="3">
      <v-select
        v-model="filterGraphic"
        :items="selectOptions.graphics"
        :menu-props="{ offsetY: true }"
        label="Graphic"
        item-text="name"
        item-value="id"
        outlined
        hide-details
        dense />
    </v-col>
    <v-col cols="3">
      <v-select
        v-model="filterCreative"
        :items="selectOptions.creatives"
        :menu-props="{ offsetY: true }"
        label="Creative"
        item-text="name"
        item-value="id"
        outlined
        hide-details
        dense />
    </v-col>
    <v-col cols="3">
      <v-autocomplete
        v-model="filterCollection"
        :items="selectOptions.collections"
        item-text="name"
        item-value="id"
        label="Collection"
        outlined
        hide-details
        clearable
        dense />
    </v-col>
    <v-col cols="3">
      <v-select
        v-model="filterCategory"
        class="pr-1"
        :items="selectOptions.categories"
        :menu-props="{ offsetY: true }"
        label="Category"
        item-text="name"
        item-value="id"
        outlined
        hide-details
        dense />
    </v-col>
    <v-col cols="3">
      <search-box
        v-model="filterSearch"
        @on-search="searchClicked()" />
    </v-col>
    <!-- <v-col cols="3">
      <v-select
        v-model="filterItemsPerPage"
        :items="selectOptions.itemsPerPage"
        item-text="text"
        item-value="value"
        :menu-props="{ offsetY: true }"
        label="Item Per Page"
        outlined
        hide-details
        dense />
    </v-col> -->
  </form>
</template>

<script>
import { mapActions } from 'vuex'
import PrototypeAttributeProvider from '@/resources/PrototypeAttributeProvider'
import FactoryProvider from '@/resources/FactoryProvider'
import ProductAttributeProvider from '@/resources/ProductAttributeProvider'
import SearchBox from '@/components/SearchBox.vue'
import PrototypeCategoryProvider from '@/resources/PrototypeCategoryProvider'

const FactoryService = new FactoryProvider()
const ProductAttributeService = new ProductAttributeProvider()
const PrototypeAttributeService = new PrototypeAttributeProvider()
const PrototypeCategoryService = new PrototypeCategoryProvider()

export default {
  components: { SearchBox },
  props: {
    state: {
      type: String,
      required: true
    },
    value: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      selectOptions: {
        designers: [{ name: 'ALL', value: '', id: '' }],
        factories: [{ name: 'ALL', value: '', id: '' }],
        merchandisers: [{ name: 'ALL', value: '', id: '' }],
        graphics: [{ name: 'ALL', value: '', id: '' }],
        stylists: [{ name: 'ALL', value: '', id: '' }],
        collections: [],
        itemsPerPage: [
          { value: 5, text: '5' },
          { value: 10, text: '10' },
          { value: 15, text: '15' },
          { value: 20, text: '20' },
          { value: 25, text: '25' },
          { value: 999, text: 'All' }
        ],
        categories: [{ name: 'ALL', value: '', id: '' }]
      }
    }
  },
  computed: {
    filterFactory: {
      get () {
        return this.value?.factory || ''
      },
      set (val) {
        this.$emit('input', {
          ...this.value,
          factory: val
        })
      }
    },
    filterSearch: {
      get () {
        return this.value?.search || ''
      },
      set (val) {
        this.value.search = val
      }
    },
    filterDesigner: {
      get () {
        return this.value?.designer || ''
      },
      set (val) {
        this.$emit('input', {
          ...this.value,
          designer: val
        })
      }
    },
    filterMerchandiser: {
      get () {
        return this.value?.merchandiser || ''
      },
      set (val) {
        this.$emit('input', {
          ...this.value,
          merchandiser: val
        })
      }
    },
    filterGraphic: {
      get () {
        return this.value?.graphic || ''
      },
      set (val) {
        this.$emit('input', {
          ...this.value,
          graphic: val
        })
      }
    },
    filterCreative: {
      get () {
        return this.value?.stylist || ''
      },
      set (val) {
        this.$emit('input', {
          ...this.value,
          stylist: val
        })
      }
    },
    filterItemsPerPage: {
      get () {
        return this.value?.itemsPerPage || ''
      },
      set (val) {
        this.$emit('input', {
          ...this.value,
          itemsPerPage: val
        })
      }
    },
    filterCollection: {
      get () {
        return this.value?.collectionId || ''
      },
      set (val) {
        this.$emit('input', {
          ...this.value,
          collectionId: val
        })
      }
    },
    filterCategory: {
      get () {
        return this.value?.category || ''
      },
      set (val) {
        this.$emit('input', {
          ...this.value,
          category: val
        })
      }
    }
  },
  mounted () {
    this.initSelectOptions()
  },
  methods: {
    ...mapActions({
      setSnackbar: 'Components/setSnackbar',
      setLoading: 'Components/setLoading'
    }),
    searchClicked () {
      this.$emit('input', { ...this.value, state: this.state })
    },
    async initSelectOptions () {
      try {
        this.setLoading({
          active: true,
          clickAble: false
        })

        const promised = await Promise.all([
          PrototypeAttributeService.getSquadMember({
            page: 1,
            itemsPerPage: 99999,
            sortBy: ['id'],
            sortDesc: [true]
          }),
          FactoryService.getAll(),
          ProductAttributeService.getAllProductAttribute(),
          PrototypeCategoryService.getAllMapped()
        ])

        this.selectOptions.merchandisers = promised[0].data.results
          .filter((item) => item.job === 'merchandiser')
          .map((item) => ({ id: item.id, status: item.status, name: item.name, squad: item.squad }))

        this.selectOptions.designers = promised[0].data.results
          .filter((item) => item.job === 'designer')
          .map((item) => ({ id: item.id, status: item.status, name: item.name, squad: item.squad }))

        this.selectOptions.graphics = promised[0].data.results
          .filter((item) => item.job === 'graphic')
          .map((item) => ({ id: item.id, status: item.status, name: item.name, squad: item.squad }))

        this.selectOptions.creatives = promised[0].data.results
          .filter((item) => item.job === 'creative')
          .map((item) => ({ id: item.id, status: item.status, name: item.name, squad: item.squad }))

        this.selectOptions.factories = promised[1].data.results.map((item) => ({ id: item.id, name: item.name, value: item.name }))

        this.selectOptions.collections = promised[2].data.collections
          ? promised[2].data.collections.map((item) => ({ id: item.id, name: item.name }))
          : []

        this.selectOptions.categories = promised[3].data.map((d) => ({
          ...d,
          disabled: d.name === 'UNKNOWN'
        }))

        this.selectOptions.merchandisers = [{ name: 'ALL', value: '', id: '' }, { divider: true }, ...this.selectOptions.merchandisers]
        this.selectOptions.designers = [{ name: 'ALL', value: '', id: '' }, { divider: true }, ...this.selectOptions.designers]
        this.selectOptions.factories = [{ name: 'ALL', value: '', id: '' }, { divider: true }, ...this.selectOptions.factories]
        this.selectOptions.graphics = [{ name: 'ALL', value: '', id: '' }, { divider: true }, ...this.selectOptions.graphics]
        this.selectOptions.creatives = [{ name: 'ALL', value: '', id: '' }, { divider: true }, ...this.selectOptions.creatives]
        this.selectOptions.categories = [{ name: 'ALL', value: '', id: '' }, { divider: true }, ...this.selectOptions.categories]
      } catch (error) {
        console.error('initSelectOptions', error)
        this.setSnackbar({
          value: true,
          message: `ERROR WHILE INIT OPTIONS: ${error.message}`,
          type: 'error'
        })
      } finally {
        this.setLoading({ active: false })
      }
    }
  }
}
</script>

<style lang="scss">

@media only screen and (max-width: 767px) {
  .create-sketch-btn {
    max-width: 50px;
    content: '•';
  }
}

</style>
